import { DesaplicarFacturasModal } from "../../../../referencias-tablas/clientes/datoscliente/cuentacorriente/facturas/desaplicaciones/components/DesaplicarFacturasModal";
import SaldosFacturasModal from "../../../../referencias-tablas/clientes/datoscliente/cuentacorriente/facturas/UI/SaldosFacturasModal";
import NotasCuentaCorrienteModal from "../../../../referencias-tablas/clientes/datoscliente/cuentacorriente/notasCuentaCorriente/NotasCuentaCorriente";
import DesaplicarImputacionModal from "../../../../referencias-tablas/clientes/datoscliente/cuentacorriente/recibos/desaplicaciones/components/DesaplicarImputacionModal";
import AnularRecibosModal from "../../../../referencias-tablas/clientes/datoscliente/cuentacorriente/recibos/UI/anularRecibos/AnularRecibosModal";
import SeleccionarRecibo from "../../../../referencias-tablas/clientes/datoscliente/cuentacorriente/recibos/UI/Imputaciones/SeleccionarRecibo";
import ReciboDetalleContainer from "../../../../referencias-tablas/clientes/datoscliente/cuentacorriente/recibos/UI/MostrarDetalleRecibo/ReciboDetalleContainer";
import ReceiptDialog from "../../../../referencias-tablas/clientes/datoscliente/cuentacorriente/recibos/UI/ReceiptDialog";
import ModalDeFiltros from "../../../../referencias-tablas/clientes/datoscliente/cuentacorriente/resumenDeCuenta/ModalDeFiltros";
import { MODAL_TYPES } from "../config/MODALES_TYPES";
import ModalDeEstamosTrabajando from "./ModalDeEstamosTrabajando";
import ReenviarPorMail from "./ReenviarPorMail";

const ModalManager = ({ modal, onClose, refresh, showToast }) => {
  if (!modal) return null;

  // console.log("DATAMODAL: ", modal);

  switch (modal.type) {
    case MODAL_TYPES.FILTROS:
      return (
        <ModalDeFiltros
          open
          filtros={modal.filtros}
          onApply={modal.onApply}
          onClose={onClose}
          showToast={showToast}
          showResumenOption={false}
        />
      );

    case MODAL_TYPES.FILTROS_EXPORTER:
      return (
        <ModalDeFiltros
          open
          filtros={modal.filtros}
          onApply={modal.onApply}
          onClose={onClose}
          showToast={showToast}
          showResumenOption={true}
        />
      );

    case MODAL_TYPES.DETALLE_RECIBO:
      return (
        <ReciboDetalleContainer
          open
          onClose={onClose}
          reciboId={modal.id}
          clienteData={modal.clienteData}
        />
      );

    case MODAL_TYPES.ANULAR_RECIBO:
      return (
        <AnularRecibosModal
          open
          onClose={onClose}
          idRecibo={modal.id}
          onSuccess={refresh}
          showToast={showToast}
        />
      );

    case MODAL_TYPES.DESAPLICAR_RECIBO:
      return (
        <DesaplicarImputacionModal
          open
          onClose={onClose}
          idRecibo={modal.id}
          onSuccess={refresh}
          showToast={showToast}
          getDocuments={refresh}
        />
      );

    case MODAL_TYPES.CREAR_RECIBO:
      return (
        <ReceiptDialog
          open
          onClose={() => {
            refresh();
            onClose();
            // console.log(modal);
          }}
          clienteData={modal?.clienteData}
          idNegocioCliente={modal?.clienteData?.id_negocio_cliente}
        />
      );

    case MODAL_TYPES.APLICAR_RECIBO:
      // console.log("MODAL CLIENTE DATA: ", modal.clienteData);
      return (
        <SeleccionarRecibo
          open
          onClose={onClose}
          getDocuments={refresh}
          clienteData={modal.clienteData}
          idNegocioCliente={modal?.clienteData?.id_negocio_cliente}
        />
      );

    case MODAL_TYPES.DETALLE_FACTURA:
      return (
        <SaldosFacturasModal
          open
          onClose={onClose}
          rowInfo={modal.row}
          clienteData={modal.clienteData}
        />
      );

    case MODAL_TYPES.ANULAR_FACTURA:
      return (
        <DesaplicarFacturasModal
          open
          onClose={onClose}
          datos={modal.row}
          idFactura={modal.row?.id}
          onSuccess={refresh}
          showToast={showToast}
          envasado={1}
        />
      );

    case MODAL_TYPES.ENVIAR_POR_MAIL:
      return (
        <ReenviarPorMail
          open
          onClose={onClose}
          id={modal.id}
          showToast={showToast}
        />
      );

    case MODAL_TYPES.ABRIR_NOTAS:
      return (
        <NotasCuentaCorrienteModal
          envasado={modal.envasado}
          idCliente={modal.idCliente}
          nombreCliente={modal.nombreCliente}
          onClose={onClose}
          open
          refresh={modal.refresh}
        />
      );

    case MODAL_TYPES.EN_DESARROLLO:
      return <ModalDeEstamosTrabajando open onClose={onClose} />;

    default:
      return null;
  }
};

export default ModalManager;
